// Minimum required javascript
import '../common/javascripts/shared/toggleExpand.js';
import AppLoader from '../react/AppLoader/AppLoader';
import AudioContainer from '../react/Audio/containers/AudioContainer';
import FolderDetailPage from '../react/Member/Folders/components/FolderDetailPage';
import FolderFeedbackPage from '../react/Member/Folders/components/FolderFeedbackPage';
import MyFoldersPage from '../react/Member/Folders/components/MyFoldersPage';
import WhitelistRequestFormContainer
  from '../react/Member/WhitelistRequestForm/containers/WhitelistRequestFormContainer';
import MemberContainer from '../react/Member/containers/MemberContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';

import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import SearchResultsContainer from '../react/app/Search/containers/SearchResultsContainer';
import '../react/common/Logger';
import MediaGridContainer from '../react/common/components/MediaGrid/MediaGridContainer';
import PageNotFound from '../react/common/components/PageNotFound';
import './commonAssets';

import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design-v2.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../common/stylesheets/shapes.less';
import '../global/elements/buttons.less';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      path: '/folders/feedback/:binUniqueId',
      component: FolderFeedbackPage,
    },
    {
      path: '/member',
      component: MemberContainer,
    },
    {
      path: '/member/folders/:uniqueId',
      component: FolderDetailPage,
    },
    {
      path: '/member/folders',
      component: MyFoldersPage
    },
    // NOTE: this needs to go last!
    {
      path: '*',
      component: PageNotFound,
    },
  ],
  auxApps: {
    ...NavApps,
    'audio-app': AudioContainer,
    'pop-up-container': PopUpsContainer,
    'youtube-whitelist-request-form': WhitelistRequestFormContainer,
    'nps-modal': NPSModalLoaderContainer,
    'search-results-container': SearchResultsContainer,
    'media-grid-container': MediaGridContainer,
    'react-toastify-container': ReactToastifyContainer,
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  }
});
